import { getSmoothStepPath } from '@xyflow/react';

function DefaultConnectionLine(props) {
  const {
    fromNode: { width },
    fromX,
    fromY,
    fromPosition,
    toX,
    toY,
    toPosition,
    connectionLineStyle,
  } = props;

  const [edgePath] = getSmoothStepPath({
    sourceX: fromX,
    sourceY: fromY,
    targetX: toX,
    targetY: toY,
    fromPosition,
    toPosition,
  });

  return (
    <g>
      <path style={connectionLineStyle} fill="none" d={edgePath} />
    </g>
  );
}

export default DefaultConnectionLine;
